<template>
  <history-timeline
    :filters="historyFilters"
    :items="historyItems"></history-timeline>
</template>

<script setup lang="ts">
import { computed, onMounted, shallowRef } from 'vue'
import { documentHistoryList } from '@/requests/document'
import { useDocument } from '@/pages/document/single/document'
import HistoryTimeline from '@/components/history-timeline/HistoryTimeline.vue'
import {
  HistoryTimelineFilter,
  HistoryTimelineItem,
} from '@/components/history-timeline/types'

defineOptions({
  name: 'History',
})

const { documentId } = useDocument()

type HistoryCategory =
  | 'change'
  | 'route'
  | 'approval'
  | 'review'
  | 'signing'
  | 'execution'

const categoryMap: Record<string, { label: string; color: string }> = {
  change: { label: 'ЗМІНА', color: 'deep-purple' },
  route: { label: 'МАРШРУТ', color: 'warning' },
  approval: { label: 'ПОГОДЖЕННЯ', color: 'light-blue-darken-4' },
  review: { label: 'ВІЗУВАННЯ', color: 'info' },
  signing: { label: 'ПІДПИС', color: 'success' },
  execution: { label: 'ВИКОНАННЯ', color: 'teal' },
}

const historyFilters: HistoryTimelineFilter[] = [
  { title: 'Усі', value: 'all' },
  { title: 'Підписання', value: 'signing' },
  { title: 'Погодження', value: 'approval' },
  { title: 'Маршрут', value: 'route' },
  { title: 'Зміни', value: 'change' },
  { title: 'Візування', value: 'review' },
]

const rawEvents = shallowRef<any[]>([])

const historyItems = computed<HistoryTimelineItem[]>(() =>
  rawEvents.value.map(event => {
    const category = (event.category ?? 'change') as HistoryCategory
    const meta = categoryMap[category] ?? categoryMap.change
    const user = event.user
    const fullName = user
      ? [user.surname, user.name, user.patronymic].filter(Boolean).join(' ')
      : ''

    return {
      id: event.id,
      date: event.created_at,
      category,
      type: meta.label,
      color: meta.color,
      user: fullName,
      position: user?.post ?? '',
      description: event.payload?.description ?? '',
      fields: event.payload?.fields ?? undefined,
      statusFrom: event.payload?.statusFrom ?? undefined,
      statusTo: event.payload?.statusTo ?? undefined,
      comment: event.payload?.comment ?? undefined,
    }
  })
)

onMounted(() => {
  documentHistoryList(documentId.value).then(data => {
    rawEvents.value = data
  })
})
</script>
